<template>
    <div class="page-wrapper">
        <h1>Акты <span class="data-rows-number">{{ total }}</span></h1>
        <acts-list/>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ActsList from '@/ActsList';

export default {
  name: 'ProjectActsView',

  components: {
    ActsList,
  },

  computed: {
    ...mapGetters({
      total: 'project/actsTotal',
    })
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectActsView.vue